// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {49: "969579a16c9538c2",67: "6b13b8ef530af864",}[chunkId] + ".css"
}